import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPanelComponent } from './panel.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	exports: [
		NgxPanelComponent
	],
	declarations: [
		NgxPanelComponent
	]
})
export class PanelModule {}
